import { ActionIcon, Tooltip } from '@mantine/core';

import styles from './HeaderActionIcon.module.scss';
import { Props } from './HeaderActionIcon.types';

const HeaderActionIcon = ({ icon: Icon, label, onClick, disabled, variant }: Props) => {
  return (
    <Tooltip label={label} openDelay={200}>
      <ActionIcon
        variant="filled"
        radius="xl"
        size={44}
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        className={variant === 'whatsapp' ? styles.whatsapp : undefined}
      >
        <Icon size={20} />
      </ActionIcon>
    </Tooltip>
  );
};

export default HeaderActionIcon;
